import React from "react";
import BlogItemContainer from "../containers/blog/blog-item";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import BlogData from "../data/blogs.json";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const BlogPage = () => {
    const handleScrollToHeader = () => {
        if (contRef.current) {
            const headerPosition = contRef.current.offsetTop;
            window.scrollTo({
                top: headerPosition,
                behavior: "smooth",
            });
        }
    };

    return (
        <React.Fragment>
            <Layout>
                <SEO title="NeoBlog | NeoGrowth - Lending simplified. Growth amplified." />
                <div className="wrapper">
                    <Header onPressSkipButton={handleScrollToHeader} />
                    <PageBanner
                        title="Blogs"
                        excerpt=""
                        image="/images/banner/page/blog.png"
                    />
                    <BlogItemContainer data={BlogData} />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default BlogPage;
